var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCurierCardKb = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    rx: 8,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.625 14.75c1.016 0 1.875-.82 1.875-1.875 0-1.016-.86-1.875-1.875-1.875-1.055 0-1.875.86-1.875 1.875 0 1.055.82 1.875 1.875 1.875Zm-.156 4.727c.156.156.508.273.742.273h2.539c.664 0 1.25-.547 1.25-1.25 0-.664-.586-1.25-1.25-1.25h-2.07l-2.774-2.227c-.195-.117-.547-.273-.781-.273-.273 0-.625.156-.82.313l-4.375 3.75c-.235.195-.43.625-.43.937 0 .39.234.86.547 1.055l3.203 2.148v4.297c0 .703.547 1.25 1.25 1.25.664 0 1.25-.547 1.25-1.25v-5c-.04-.352-.273-.82-.586-1.016l-1.602-1.093 2.266-1.953 1.64 1.289ZM29 21c-2.773 0-5 2.266-5 5 0 2.773 2.227 5 5 5 2.734 0 5-2.227 5-5 0-2.734-2.266-5-5-5Zm0 7.5a2.468 2.468 0 0 1-2.5-2.5c0-1.367 1.094-2.5 2.5-2.5 1.367 0 2.5 1.133 2.5 2.5 0 1.406-1.133 2.5-2.5 2.5ZM14 21c-2.773 0-5 2.266-5 5 0 2.773 2.227 5 5 5 2.734 0 5-2.227 5-5 0-2.734-2.266-5-5-5Zm0 7.5a2.468 2.468 0 0 1-2.5-2.5c0-1.367 1.094-2.5 2.5-2.5 1.367 0 2.5 1.133 2.5 2.5 0 1.406-1.133 2.5-2.5 2.5ZM15.091 17.381c.234.235.625.274.86.078l4.062-3.476a.619.619 0 0 0 .078-.86c-1.133-1.328-3.008-1.523-4.258-.468l-2.265 1.914a.619.619 0 0 0-.079.86l1.602 1.952Z",
    fill: "#E25F6C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCurierCardKb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/curier-card-kb.d04cb5eb17ce7bf9a20eb41ef49667a6.svg";